import { render, staticRenderFns } from "./haoka17.vue?vue&type=template&id=72c79fc9&scoped=true&"
import script from "./haoka17.vue?vue&type=script&lang=js&"
export * from "./haoka17.vue?vue&type=script&lang=js&"
import style0 from "./haoka17.vue?vue&type=style&index=0&id=72c79fc9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c79fc9",
  null
  
)

export default component.exports